var $2956757ac31a7ce2$exports = {};
$2956757ac31a7ce2$exports = {
  "ascending": "nara\u0161\u010Dajo\u010De",
  "ascendingSort": function ascendingSort(args) {
    return "razvr\u0161\u010Deno po stolpcu ".concat(args.columnName, " v nara\u0161\u010Dajo\u010Dem vrstnem redu");
  },
  "columnSize": function columnSize(args) {
    return "".concat(args.value, " slikovnih pik");
  },
  "descending": "padajo\u010De",
  "descendingSort": function descendingSort(args) {
    return "razvr\u0161\u010Deno po stolpcu ".concat(args.columnName, " v padajo\u010Dem vrstnem redu");
  },
  "resizerDescription": "Pritisnite tipko Enter da za\u010Dnete spreminjati velikost",
  "select": "Izberite",
  "selectAll": "Izberite vse",
  "sortable": "razvrstljivi stolpec"
};
export { $2956757ac31a7ce2$exports as default };